import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../Common/Input/Input';
import ButtonPrimary from '../../../../../Common/Button/Primary/ButtonPrimary';
import AuthBetweenLink from '../../../../Features/AuthBetweenLink/AuthBetweenLink';
import StepTitle from '../../../../Features/StepTitle/StepTitle';
import StepDescription from '../../../../Features/StepDescription/StepDescription';
import styles from './PasswordRecoverySentLink.module.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { recovery } from '../../passwordRecoverySlice';
import { useAppSelector } from '../../../../../../config/redux/hooks';
import { useNotification } from '../../../../../Common/Notification/notify';

function PasswordRecoverySentLink() {
  const { t } = useTranslation();
  const notify = useNotification();
  const dispatch = useDispatch();
  const waitingForConfirmation = useAppSelector(state => state.auth.passwordRecovery.waitingForConfirmation);
  const error = useAppSelector(state => state.auth.passwordRecovery.error);

  useEffect(() => {
    if (waitingForConfirmation) {
      formik.resetForm();
      //todo show text about sent email
    }
  }, [ waitingForConfirmation ])

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t('common.form.validation.email')).required(t('common.form.validation.required')),
    }),
    onSubmit: values => {
      dispatch(recovery(values.email));
    },
  });


  useEffect(() => {
    if (error) {
      notify.error(t(error));
    }
  }, [ error ])

  return (
    <div className={styles.container}>
      <StepTitle>{t('recovery.password.title')}</StepTitle>
      <StepDescription>{t('recovery.password.description')}</StepDescription>
      <form className={styles.form} onSubmit={formik.handleSubmit} >
        <Input
          id={'email'}
          name={'email'}
          type={'email'}
          label={t('recovery.password.input.label')}
          placeholder={t('common.form.placeholder.email')}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          touched={formik.touched.email}
          error={formik.errors.email}
        />
        <div className={styles.buttonContainer}>
          <ButtonPrimary type={'submit'} disabled={!(formik.isValid && formik.dirty)} label={t('recovery.password.button')} />
          <AuthBetweenLink title={t('recovery.password.link.title')} link={'/auth/login'} linkText={t('recovery.password.link.text')}/>
        </div>
      </form>
    </div>
  )
}

export default PasswordRecoverySentLink